import baseMixin from './baseMixin'
import {
    styler,
    spring,
    tween,
    delay,
    chain,
    action,
    easing,
    composite
} from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'privacy-policy-graphic'
    },

    methods: {
        setStyler() {
            this.from = this.baseElement.querySelector('#pp-blinds-up')
            this.fromSize = this.from.getBBox()
            this.to = this.baseElement.querySelector('#pp-blinds-down')
            this.to.style.opacity = 0
            this.toSize = this.to.getBBox()
            this.blinds = styler(this.from)
            this.deltaScaleY = this.toSize.height / this.fromSize.height
            this.deltaY = (this.toSize.height - this.fromSize.height) / 2
            this.originY = this.blinds.get('originY')
        },

        initAction() {
            return composite({
                opacity: chain(
                    tween({
                        from: { opacity: 1 },
                        to: { opacity: 0 },
                        duration: 250
                    }),
                    delay(100),
                    tween({
                        from: { opacity: 0 },
                        to: { opacity: 1 },
                        duration: 250
                    })
                ),
                reset: chain(
                    delay(300),
                    action(({ update, complete }) => {
                        update({ scaleY: 1, y: 0 })
                        complete()
                    })
                )
            })
        },

        animationAction() {
            return chain(
                delay(500),
                spring({
                    from: { scaleY: 1, y: 0 },
                    to: { scaleY: this.deltaScaleY, y: this.deltaY },
                    stiffness: 80,
                    damping: 10,
                    mass: 2
                })
            )
        },

        animationReaction(v) {
            this.blinds.set(v)
        },

        initReaction(values) {
            if (!values) return
            const { opacity, reset } = values
            opacity && this.blinds.set(opacity)
            reset && this.blinds.set(reset)
        }
    }
}
